export const scrollToHeader = (id: string | undefined) => {
	if (!id) return;
	const escapedId = id.replace(/[.:;*+?^$!@$^&~%{}()=/|[\]\\]/g, '\\$&');
	const pmodeContent = document.querySelector(`#presenter-mode-container ${escapedId}`);
	if (pmodeContent) {
		pmodeContent.scrollIntoView();
	}
};
